// extracted by mini-css-extract-plugin
module.exports = {"root":"EditVenueDescriptionPanel_root__3NAwg","form":"EditVenueDescriptionPanel_form__qVg7_","title":"EditVenueDescriptionPanel_title__2ImlP"};